import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// Função para inicializar a aplicação
const initializeApp = async () => {
  try {
    // Verificar se o elemento raiz existe
    const rootElement = document.getElementById('root');
    console.log('Verificando elemento raiz...');
    if (!rootElement) {
      console.error("Elemento raiz não encontrado. Verifique se o elemento com id 'root' existe no arquivo index.html.");
      throw new Error("Elemento raiz não encontrado.");
    }
    console.log('Elemento raiz encontrado.');

    // Renderizar a aplicação
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Erro ao inicializar a aplicação:', error);
    // Mostrar mensagem de erro amigável para o usuário
    const errorElement = document.createElement('div');
    errorElement.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      text-align: center;
      font-family: system-ui, -apple-system, sans-serif;
    `;
    errorElement.innerHTML = `
      <h2 style="color: #e11d48; margin-bottom: 10px;">Ops! Algo deu errado.</h2>
      <p style="color: #4b5563;">Não foi possível carregar a aplicação. Por favor, tente novamente mais tarde.</p>
    `;
    document.body.appendChild(errorElement);
  } finally {
    // Remover o loader inicial se existir
    const loader = document.getElementById('loader');
    if (loader) {
      loader.remove();
    }
  }
};

// Inicializar a aplicação
initializeApp();